import { render, staticRenderFns } from "./revoke.vue?vue&type=template&id=039d5a71&scoped=true&"
import script from "./revoke.vue?vue&type=script&lang=js&"
export * from "./revoke.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039d5a71",
  null
  
)

export default component.exports